// turnstileToken.ts — cuándo un token de Cloudflare Turnstile deja de ser confiable.
//
// Round 2026-10-28. Un token vive ~300 s y se gasta al validarlo. El widget avisa del
// vencimiento con `onExpire` y se renueva con `refreshExpired="auto"`, pero ambos dependen de
// timers del navegador, y en una app instalada en el celular el sistema SUSPENDE la app en
// cuanto sales de ella (WhatsApp para copiar la clave, el gestor de contraseñas...): al volver,
// el token ya venció y el widget aún no se enteró. Por eso el login mira la edad del token por
// su cuenta, al volver a primer plano y justo antes de enviar.

/** Vida útil real del token en Cloudflare. */
export const TURNSTILE_TTL_MS = 300_000;
/** Se renueva a los 240 s: deja 60 s de margen para tipear y enviar. */
export const TURNSTILE_RENOVAR_MS = 240_000;

/**
 * ¿Hay que pedir un token nuevo? `issuedAt` = ms epoch en que llegó el token (0 = no hay).
 * Sin token no hay nada que renovar a la fuerza (el widget ya está pidiendo uno).
 */
export function tokenTurnstileVencido(issuedAt: number, ahora: number): boolean {
  if (!issuedAt) return false;
  return ahora - issuedAt >= TURNSTILE_RENOVAR_MS;
}
